"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zuoraData = void 0;
var utm_from_url_1 = require("./utm-from-url");
// Replace underscore and whitespace with dash
var sanitizeUtmTags = function (str) { return str === null || str === void 0 ? void 0 : str.replace(/[_\s]/gi, '-'); };
var NO_DATA = 'unknown';
/**
 * Add brand domains to this list to be able to track the source of the user
 */
var internalHostNames = {
    'vg.no': 'vg',
    'aftenbladet.no': 'sa',
    'bt.no': 'bt',
    'e24.no': 'e24',
    'vink.aftenposten.no': 'vink', // Must be before aftenposten
    'aftenposten.no': 'ap',
};
var externalHostNames = {
    'facebook.com': 'facebook',
    'messenger.com': 'messenger',
    google: 'google',
    instagram: 'instagram',
    linkedin: 'linkedin',
    'lnkd.in': 'linkedin',
    snapchat: 'snapchat',
    'sol.no': 'sol',
    slack: 'slack',
};
function referrerInHostList(host, hostList) {
    return (Object.keys(hostList).find(function (partialHost) { return host.includes(partialHost); }) ||
        false);
}
function getMatchingReferrer(referrer) {
    var matchingReferrer = referrerInHostList(referrer.host, internalHostNames);
    if (matchingReferrer) {
        return {
            type: 'internal',
            matchingReferrer: matchingReferrer,
        };
    }
    matchingReferrer = referrerInHostList(referrer.host, externalHostNames);
    if (matchingReferrer) {
        return {
            type: 'external',
            matchingReferrer: matchingReferrer,
        };
    }
    return {
        type: 'unknown',
        matchingReferrer: '',
    };
}
function getInternalSource(matchingReferrer, referrer) {
    if (referrer.pathname.search(/^\/?$/) >= 0) {
        return "".concat(internalHostNames[matchingReferrer], "-front");
    }
    if (referrer.pathname.search(/\/i\/[a-zA-Z0-9]+\//) >= 0) {
        return "".concat(internalHostNames[matchingReferrer], "-article");
    }
    if (referrer.pathname.search(/\/([a-z-]+)[/]?$/) >= 0) {
        return "".concat(internalHostNames[matchingReferrer], "-listing");
    }
    return "".concat(internalHostNames[matchingReferrer], "-unknown");
}
function getExternalSource(matchingReferrer, rQuery) {
    if (rQuery) {
        return "".concat(externalHostNames[matchingReferrer], "-spons");
    }
    return externalHostNames[matchingReferrer];
}
function getSourceFromReferrerAndQuery(referrer, rQuery) {
    var _a = getMatchingReferrer(referrer), type = _a.type, matchingReferrer = _a.matchingReferrer;
    if (type === 'internal') {
        return getInternalSource(matchingReferrer, referrer);
    }
    if (type === 'external') {
        return getExternalSource(matchingReferrer, rQuery);
    }
    return 'unknown';
}
/**
 * Function to create the tracking parameters used by Zuora/URS
 * @param baseProps Required properties for the tracking parameters
 * @param salesposterElem The parsed salesposter element
 * @param docRef The url of the current page
 * @returns Object with the tracking parameters
 */
var zuoraData = function (baseProps, salesposterElem) {
    var contentId = baseProps.contentId, contentType = baseProps.contentType, docRef = baseProps.docRef, _a = baseProps.hasSalesLeadBody, hasSalesLeadBody = _a === void 0 ? false : _a, _b = baseProps.paywallType, paywallType = _b === void 0 ? '' : _b, _c = baseProps.query, _d = _c === void 0 ? {} : _c, _e = _d.r, rQuery = _e === void 0 ? '' : _e, utmTags = baseProps.utmTags, utmUrlDefault = baseProps.utmUrlDefault, windowLocationHref = baseProps.windowLocationHref;
    // TODO Once we know where to put it
    // const frontpageVariant = getLocalHistoryMetaByKey('curate')?.insightVersion;
    var documentReferrer = docRef.split(/[?#]/)[0];
    var referrer;
    try {
        referrer = new URL(documentReferrer);
    }
    catch (_f) {
        referrer = null;
    }
    var salesposterCampaign = salesposterElem.campaign, salesposterPosterType = salesposterElem.posterType;
    var salesLeadFlag = hasSalesLeadBody ? '-lead' : '';
    var utmValues = utmTags || (0, utm_from_url_1.utmFromUrl)(windowLocationHref);
    var _g = utmValues.utm_content, utm_content = _g === void 0 ? '' : _g, _h = utmValues.utm_campaign, utm_campaign = _h === void 0 ? '' : _h, _j = utmValues.utm_source, utm_source = _j === void 0 ? '' : _j, _k = utmValues.utm_medium, utm_medium = _k === void 0 ? '' : _k, _l = utmValues.utm_term, utm_term = _l === void 0 ? '' : _l, 
    // utm_url defaults to the current page
    _m = utmValues.utm_url, 
    // utm_url defaults to the current page
    utm_url = _m === void 0 ? utmUrlDefault ||
        windowLocationHref.split(/[?#]/)[0].replace(/\/$/, '') : _m;
    function getSource() {
        if (utm_source) {
            return sanitizeUtmTags(utm_source);
        }
        if (!referrer)
            return NO_DATA;
        return getSourceFromReferrerAndQuery(referrer, rQuery);
    }
    var data = {
        utm_source: getSource(),
        utm_medium: sanitizeUtmTags(utm_medium) || paywallType || NO_DATA,
        utm_content: (sanitizeUtmTags(utm_content) || salesposterPosterType || NO_DATA) +
            salesLeadFlag,
        utm_campaign: sanitizeUtmTags(utm_campaign) || salesposterCampaign || NO_DATA,
        utm_term: sanitizeUtmTags(utm_term) || NO_DATA,
        utm_url: sanitizeUtmTags(utm_url) || NO_DATA,
        content_id: contentId || NO_DATA,
        type: contentType,
        // device: deviceType || NO_DATA, Might be added later
    };
    return data;
};
exports.zuoraData = zuoraData;
//# sourceMappingURL=zuora-params.js.map